import { FC } from 'react'
import styles from './TrophyMemoryCardList.module.scss'
import { TrophyMemoryDto } from '~/modules/Trophies/Infrastructure/TrophyDetailComponentDto'
import { TrophyMemoryCard } from '~/modules/TrophyMemories/Infrastructure/Components/TrophyMemoryCard'
import { TrophyMemoryCardSkeleton } from '~/modules/TrophyMemories/Infrastructure/Components/TrophyMemoryCardSkeleton'

interface Props {
  memories: TrophyMemoryDto []
}
export const TrophyMemoryCardList: FC<Props> = ({ memories }) => {
  const numberOfSkeletonMemories = 5 - memories.length
  const skeletonMemories = Array.from(Array(numberOfSkeletonMemories).keys())
    .map((index) => (<TrophyMemoryCardSkeleton key={ index } />))

  return (
    <div className={ styles.trophyMemoryCardList__container }>
      {
        memories.map((memory) => (
          <TrophyMemoryCard
            memoryCardDto={ memory }
            key={ memory.id }
          />
        ))
      }
      { skeletonMemories }
    </div>
  )
}
